module.exports = __webpack_public_path__ + "static/media/360-degrees.95888695.svg";